'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChildAccordionSectionNodes = getChildAccordionSectionNodes;
exports.insertChildOrderly = insertChildOrderly;

function _toArray(arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
}

function getChildAccordionSectionNodes(ref) {
  if (ref) {
    return ref.querySelectorAll('li.rainbow-accordion-section_container');
  }

  return [];
}

function getRefIndex(nodes, ref) {
  return nodes.indexOf(ref);
}

function sortChildren(childrenRefs, nodes) {
  var _childrenRefs = _toArray(childrenRefs),
      newChildrenRefs = _childrenRefs.slice(0);

  newChildrenRefs.sort(function (refA, refB) {
    return getRefIndex(nodes, refA.ref) - getRefIndex(nodes, refB.ref);
  });
  return newChildrenRefs;
}

function insertChildOrderly(childrenRefs, childRef, nodes) {
  var newChildrenRefs = childrenRefs.concat([childRef]);
  return sortChildren(newChildrenRefs, nodes);
}